import { TIME_AM, TIME_DELIMITER, TIME_PM } from '../constants';

function isInvalidParsedTimeValue(timeArr: number[], isAm: boolean, isPm: boolean): boolean {
  return timeArr.some((num, i) => {
    if (isNaN(num) || !Number.isInteger(num) || num < 0) {
      return true;
    }

    if (i === 0) {
      if (!isAm && !isPm && num > 23) {
        return true;
      }
      if ((isAm || isPm) && (num < 1 || num > 12)) {
        return true;
      }
    }

    if (i > 0 && num > 59) {
      return true;
    }

    return false;
  });
}

export function parseTime(timeStr: string): number[] | null {
  if (!timeStr) {
    return null;
  }

  const timeStrChunks = timeStr.split(TIME_DELIMITER);

  if (timeStrChunks.length < 2 || timeStrChunks.length > 3) {
    return null;
  }

  const lastChunk = timeStrChunks[timeStrChunks.length - 1];
  const ampm = lastChunk.slice(-2).toUpperCase();
  const isAm = ampm === TIME_AM;
  const isPm = ampm === TIME_PM;

  if (isAm || isPm) {
    timeStrChunks[timeStrChunks.length - 1] = lastChunk.substring(0, lastChunk.length - 2);
  }

  const timeArr = timeStrChunks.map((val) => Number(val.trim()));

  if (isInvalidParsedTimeValue(timeArr, isAm, isPm)) {
    return null;
  }

  timeArr[0] = isAm && timeArr[0] === 12 ? 0 : timeArr[0];
  timeArr[0] = isPm && timeArr[0] !== 12 ? timeArr[0] + 12 : timeArr[0];
  return timeArr;
}
